import { forOwn, isArray, isObject, omit } from 'lodash-es';

export function removeProps(obj: any, ...propsToRemove: string[]): any {
  if (isArray(obj)) {
    return obj.map((o) => removePropsDeep(o, propsToRemove));
  }

  return removePropsDeep(obj, propsToRemove);
}

function removePropsDeep(obj: any, propsToRemove: string[]): any {
  if (!isArray(obj) && !isObject(obj)) {
    return obj;
  }
  const o = {};
  forOwn(obj, (value: any, key: string) => {
    o[key] = removeProps(value, ...propsToRemove);
  });
  return omit(o, propsToRemove);
}
